// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yPOSm","body":"styles_body__+xbx7"};